import { render, staticRenderFns } from "./PackingCheck.vue?vue&type=template&id=19b887da&scoped=true"
import script from "./PackingCheck.vue?vue&type=script&lang=js"
export * from "./PackingCheck.vue?vue&type=script&lang=js"
import style0 from "./PackingCheck.vue?vue&type=style&index=0&id=19b887da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b887da",
  null
  
)

export default component.exports